import type { TableQuery } from 'ab-common/dataStructures/tableQuery';

import baseRoute from '../baseRoute';

export type * from './queryParams';
export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/organization/${string | ':orgAlias'}/members/table${`?query=${string}` | ''}`;

export const ROUTE: RouteDefinition = `${baseRoute}/organization/:orgAlias/members/table`;

export const URL = (tableQuery: TableQuery, orgAlias: string): RouteDefinition => `${baseRoute}/organization/${orgAlias}/members/table?query=${encodeURIComponent(JSON.stringify(tableQuery))}`;
